import { EnumAgentUserStatus } from "@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/SwapAgent";
import { ApiResult } from "../../../../api/types";
import { useTranslation } from '../../../../hooks';
import { toDisplayTime } from '../../../../utils';
import { GetListRes } from '../types/GetListRes';
import { TableColumnKey, TableRow } from '../types/Table';

import { EnumCreditCardStatus } from "@wallet-manager/pfh-pmp-node-def-types/dist/src/ApiEnum";
import { EnumE6CardState } from "@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master";

interface UseTableRowsProps {
  apiList: ApiResult<GetListRes>;
}

type ConvertToTableRowsType = (apiList: ApiResult<GetListRes>) => TableRow[];

const useTableRows = (props: UseTableRowsProps) => {
  const { apiList } = props;

  const { translate } = useTranslation();

  const translateStatus = (status: number) => {
    if (!EnumCreditCardStatus[status]) return '';

    return translate(`enumConstants.${EnumCreditCardStatus[status]}`);
  };

  const translateE6CardStatus = (status: number) => {
    if (!EnumE6CardState[status]) return '';
    
    return translate(`enumConstants.${EnumE6CardState[status]}`)
  }

  const convertToTableRows: ConvertToTableRowsType = (apiList) => {
    if (!apiList || !apiList?.rows) return [];

    const tableRows = apiList?.rows.map((row, index): TableRow => {
      const cardExpiryDisplayValue =
        row.expiry.slice(0, 4) + "/" + row.expiry.slice(-2);
      const convertTrueFalseToYesNo = (value: boolean) => {
        return value ? "Yes" : "No";
      };
      return {
        id: index,
        [TableColumnKey.distributorAgentId]: row.distributorAgentId,
        [TableColumnKey.orderId]: row.orderId,
        [TableColumnKey.orderSequence]: row.orderSeq,
        [TableColumnKey.programName]: row.programName,
        [TableColumnKey.cardProfileName]: row.cardProfileName,
        [TableColumnKey.status]: translateStatus(row.status),
        [TableColumnKey.pfhNumber]: row.customerNumber,
        [TableColumnKey.embossedName]: row.embossedName,
        [TableColumnKey.cardNumber]: row.cardNumber,
        [TableColumnKey.panLast4]: row.panLast4,
        [TableColumnKey.cardType]: row.type,
        [TableColumnKey.cardCreatedTime]: toDisplayTime(row.cardCreateTime),
        [TableColumnKey.cardExpiryTime]: cardExpiryDisplayValue,
        [TableColumnKey.e6CardStatus]: translateE6CardStatus(row.state),
        [TableColumnKey.statusUpdateTime]: toDisplayTime(row.stateUpdatedTime),
        [TableColumnKey.preCreatedCard]: translate(convertTrueFalseToYesNo(row.preCreatedCard)),
        [TableColumnKey.imported]: translate(convertTrueFalseToYesNo(row.imported)),
        [TableColumnKey.blocked]: translate(convertTrueFalseToYesNo(row.blocked)),
        [TableColumnKey.reissued]: translate(convertTrueFalseToYesNo(row.reissue)),
        [TableColumnKey.reissueOrderId]: row.reissueOrderId,
        [TableColumnKey.originalCardNumber]: row.oldCardNumber,
        [TableColumnKey.deactivatedOriginalCardOnActivation]: translate(convertTrueFalseToYesNo(row.deactivateOnNewCardActivation)),
        [TableColumnKey.cardActivationTime]: toDisplayTime(row.cardActivatedDate),
        [TableColumnKey.creationTime]: toDisplayTime(row.createdDate),
        [TableColumnKey.lastModifiedTime]: toDisplayTime(row.lastModifiedDate),

        rawData: row,
      };
    });

    return tableRows;
  };

  const rows = convertToTableRows(apiList);

  return { rows, totalCounts: apiList.count, convertToTableRows };
};

export default useTableRows;